/**
 * Textos compartidos del dashboard (`/app/dashboard`).
 * Centralizados aquí para no repetir literalidades en cada componente y
 * para mantenir un lenguaje de negocio: nunca "bot", nunca "IA" en copy
 * de lectura.
 */
export const dashboardCopy = {
  attentionTitle: 'Requiere atención',
  allCaughtUp: 'Todo al día',
  allCaughtUpHint: 'Nada pendiente de configuración ni de confirmación del equipo.',

  conversationsOpen: 'Conversaciones abiertas',
  messages: 'Mensajes',
  attendedByAssistant: 'Atendido por el asistente',
  assistantResponseTime: 'Respuesta del asistente',

  withoutData: 'Sin datos suficientes',
  noPreviousPeriod: 'Sin período anterior para comparar',
  sameAsPrevious: 'Igual que el período anterior',
  previousPeriodDelta: (value: string) => `${value} vs período anterior`,

  disconnectedChannel: 'Canal sin conexión',
  noChannels: 'Sin canales conectados',
  noChannelsHint: 'Conecta WhatsApp para empezar a atender.',
  connectChannel: 'Conectar canal',

  pendingDoubtsRow: (count: number) => (count === 1 ? 'consulta del asistente espera respuesta del equipo' : 'consultas del asistente esperan respuesta del equipo'),
  reviewInbox: 'Revisar bandeja',

  pendingOrdersRow: (count: number) => (count === 1 ? 'pedido por confirmar' : 'pedidos por confirmar'),
  reviewOrders: 'Revisar pedidos',

  pendingAppointmentsRow: (count: number) => (count === 1 ? 'cita pendiente de confirmar' : 'citas pendientes de confirmar'),
  reviewAppointments: 'Revisar agenda',
} as const
